export const WEB_TRIAL_APP_TOKEN = '1429889f-7c31-4b1d-a280-e94ec0704262';
export const WEB_TRIAL_CLIENT_TOKEN = 'pubf43fcf8de511ce458f04cbdf8dc2deb6';
